import {
  CREATE_PARTICIPANT,
  CREATE_PARTICIPANT_SUCCESS,
  CREATE_PARTICIPANT_ERROR,
  UPDATE_PARTICIPANT_STATE,
  GET_PARTICIPANT_COLLECTION,
  GET_PARTICIPANT_COLLECTION_SUCCESS,
  GET_PARTICIPANT_COLLECTION_ERROR
} from "../actions";

const INIT_STATE = {
  isParticipantRecordPanelShown: false,
  loading: false,
  participantCreateError: null,
  participantCollectionGetError: null,
  participantSaved: null,
  participantCollectionId: null,
  parentCollectionIdOfParticipantCollection: null,
  participantCollection: null,
  relationOfCollection: null,
  relationTypeCollection: null,
  relationOfNode: null
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CREATE_PARTICIPANT:
      return { ...state, loading: true, participantCreateError: null };
    case CREATE_PARTICIPANT_SUCCESS:
      return { ...state, loading: false, participantCreateError: null, participantSaved: action.payload, isNewRecordPanelShown: false };
    case CREATE_PARTICIPANT_ERROR:
      return { ...state, loading: false, participantCreateError: action.payload.message };
    case GET_PARTICIPANT_COLLECTION:
      return { ...state, loading: true, participantCollectionGetError: null, participantCollectionId: action.payload.participantCollectionId, parentCollectionIdOfParticipantCollection: action.payload.parentCollectionIdOfParticipantCollection };
    case GET_PARTICIPANT_COLLECTION_SUCCESS:
      return { ...state, loading: false, participantCollectionGetError: null, participantCollection: action.payload.collection, relationOfCollection: action.payload.relationOfCollection, relationTypeCollection: action.payload.relationTypeCollection, relationOfNode: action.payload.relationOfNode, isNewRecordPanelShown: false };
    case GET_PARTICIPANT_COLLECTION_ERROR:
      return { ...state, loading: false, participantCollectionGetError: action.payload.message };
    case UPDATE_PARTICIPANT_STATE:
      return { ...state, ...action.payload.updatedValues }
    default:
      return { ...state };
  }
};
